export const CustomTabletPortrait = '(min-width: 600px) and (max-width: 950px) and (orientation: portrait)';